<template>
  <div :class="['dialogBox', isRight==1?'dialogBox_small':isRight==2?'dialogBox_big':'']">
    <!-- 对话记录 -->
    <div class="dialog-flex" v-if="actDialogId != '' || notNew" ref="dialogflex">
      <!-- 加载中:骨架图 -->
      <template v-if="sessionLoading">
        <loadingSkeleton></loadingSkeleton>
      </template>
      <!-- 对话记录 -->
      <template v-else>
        <div class="dialog-item" v-for="(item, index) in dialoglist" :key="index">
          <!-- 问题 -->
          <div class="me">
            <span class="head-user">{{ Avatar }}</span>
            <div class="question">
              <p>{{ item.sendContent }}</p>
            </div>
          </div>
          <!-- 回答 -->
          <div class="rebot">
            <div class="rebot-content">
              <svg-icon class="airebot" name="airebot"></svg-icon>
              <div class="answer">
                <div class="answer-wrap">
                  <p>
                    <!-- 是否加载回答中 -->
                    <span v-if="isShowLoading(index)" class="dot-flashing"></span>
                    <template v-else>
                      <searchList :item="item"></searchList>
                      <span v-if="item.searchState && item.searchState != 3" class="dot-flashing"></span>
                      <!-- <vue-markdown :source="qusetiontextarea"></vue-markdown> -->
                      <vue-markdown :source="item.replyContent" :linkify="false" :anchorAttributes="{target: '_blank'}"></vue-markdown>
                    </template>
                  </p>
                  <div v-if="isShowLoadingMore(index)">
                    <el-divider></el-divider>
                    <span class="dot-flashing"></span>
                  </div>
                  <!-- dataType为1、2、3、4且有数据去绘制对应图表;-1是正常GPT对话(无数据渲染);-2是市场研究报告分析(单独处理) -->
                  <div v-if="item.dataType > 0 && (item.tabledata.result.length > 0 || (item.chartdata && Object.keys(item.chartdata).length))" class="extra-box">
                    <el-divider></el-divider>
                    <dataList :datalist.sync="item"></dataList>
                  </div>
                  <div v-else-if="item.dataType == -2 && item.jsonData && item.jsonData.recommendQ && (item.jsonData.recommendQ.length > 0 || item.jsonData.idTitle.length > 0)" class="extra-box">
                    <el-divider></el-divider>
                    <span class="firstQ">{{ $i18.language("了解详细信息") }}</span>
                    <moreReport :data.sync="item" @setQusetType="setQusetType" @sendQuest="sendQuest"></moreReport>
                  </div>
                  <div v-else-if="item.dataType == -3" class="extra-box">
                    <el-divider></el-divider>
                    <moreReport :data.sync="item"></moreReport>
                  </div>
                </div>
                <!-- 重新生成、复制、点赞、踩 -->
                <div class="answer-option" v-show="isShowOption(index)">
                  <span class="rebuild" @click="rebuild(item)">{{ $i18.language("重新生成") }}</span>
                  <div class="right-option">
                    <div class="copy-button" @click="copy(item.replyContent)">
                      <svg-icon name="copy"></svg-icon>
                    </div>
                    <div @click="feedback(item, 1)" :class="[item.score==1?'actived' : '']">
                      <svg-icon name="like" :class="[showAnimate==item.uniqueKey?'liked':'']" @animationend="showAnimate=''"></svg-icon>
                    </div>
                    <div @click="moreFeedback(item)" :class="[item.score && item.score!=1 && item.score!=0 ? 'actived' : '']">
                      <svg-icon name="dislike"></svg-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 首次登陆 -->
    <template v-else>
      <pre-loading ref="preLoading" :isRight.sync="isRight"></pre-loading>
    </template>
    <!-- 输入框 -->
    <div class="input-box">
      <div class="blur-box"></div>
      <div class="type-btn">
        <!-- 提问类型 -->
        <el-dropdown placement="top" trigger="click">
          <el-button plain :class="[questionType?'checkedQuestType':'']">
            {{ questionTypeText }}
            <svg-icon v-if="questionType" :name="questionTypeIconName"></svg-icon>
            <span v-if="questionType" class="questionTypeText">{{ getQuestionType(questionType) }}</span>
            <svg-icon name="changetype"></svg-icon>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <div class="dropdown-option">
              <div class="dropdown-item" v-for="item in questionTypeList" :key="item.value" @click="changeQuestionType(item)">
                <svg-icon :name="item.key"></svg-icon>
                <span class="question-type">{{ item.text }}</span>
                <div class="radio">
                  <svg-icon class="check_status" v-if="questionType == item.value" name="checked"></svg-icon>
                  <svg-icon class="check_status" v-else name="uncheck"></svg-icon>
                </div>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-if="questionType == 4" plain @click="changeReport" class="reportBtn">
          <div v-if="!reportInfo">{{ $i18.language("选择具体报告") }}</div>
          <template v-else>
            <svg-icon class="pdf" name="pdf" style="font-size: 20px;vertical-align: -0.25em;"></svg-icon>
            <span class="reportTitle">{{ reportInfo.en_title || reportInfo.title }}</span>
            <span @click.stop="clearBtn" class="clearReport">
              <svg-icon name="deleteIcon"></svg-icon>
            </span>
          </template>
        </el-button>
        <el-popover
          popper-class="websearch-popover"
          placement="top-start"
          trigger="hover"
          :content="webSearchTip">
          <el-button v-show="questionType != 4" slot="reference" plain @click="openWebSearch" :class="[QA_args.webSearch?'webSearch-on-btn':'', 'webSearch-btn']">
            <svg-icon :name="QA_args.webSearch?'global':'no_global'"></svg-icon>
            <span>{{ QA_args.webSearch?$i18.language("已联网"):$i18.language("联网") }}</span>
          </el-button>
        </el-popover>
        <el-button v-if="isRight==1" class="confirm-btn-plain addDialogBtn" plain @click="newDialog">{{ $i18.language("新建对话") }}</el-button>
      </div>
      <!-- 文本域 -->
      <div class="input-textarea">
        <span class="lengthTips">{{ qusetiontextarea.length }} / 1000</span>
        <el-input ref="inputRef" type="textarea" @keydown.native="changeInput" :maxlength="1000" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$i18.language('Enter 发送；Shift/Cmd + Enter 换行')" v-model="qusetiontextarea"></el-input>
        <el-button :style="lang=='en'?'bottom: 40px':''" class="sendQusetion" @click="sendQusetion">{{ $i18.language("发送") }}</el-button>
        <span class="bottom-desc" v-if="['TR'].includes($util.judgeOrigin())">{{ $i18.language("内容由AI生成，仅供参考，请遵守《特易用户协议》，特易GT大模型版本：V6.0.0(TRU)") }}</span>
        <span class="bottom-desc" v-else>{{ $i18.language("内容由AI生成，仅供参考，请遵守《特易用户协议》，特易GT大模型版本：V6.0.0") }}</span>
      </div>
    </div>
    <feedBack v-if="feedbackType.dialogVisible" :feedbackType.sync="feedbackType"></feedBack>
    <marketReport ref="marketReport" @selectReport="selectReport"></marketReport>
  </div>
</template>

<script>
import _ from "lodash";
import Clipboard from 'clipboard'
import preLoading from './preLoading'
import loadingSkeleton from './loadingSkeleton'
import dataList from './dataList'
import tradeTableData from './tradeTableData'
import marketReport from './marketReport'
import feedBack from './feedBack'
import moreReport from './moreReport'
import searchList from './searchList'
import VueMarkdown from 'vue-markdown';
import { createParser } from 'eventsource-parser';
import Context from '../states/gptStreamStates';

export default {
  components: {
    dataList,
    feedBack,
    preLoading,
    moreReport,
    searchList,
    marketReport,
    tradeTableData,
    loadingSkeleton,
    VueMarkdown,
  },
  props: {
    isRight: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      notNew: false,
      QA_args: {
        webSearch: false
      },
      isLoadingMore: false,
      actDialogId: '', // 当前会话id
      dialoglist: [], // 会话中所有的QA对话
      answerLoading: 0, // 生成回答状态: 0已完成1准备加载2加载中
      regenerated: 0, // 是否重新生成: 1是重新生成，0不是
      sessionLoading: false, // 历史会话加载中
      importAreaChartLoading: false, // treeMap图表
      chartData: {chart: {}},
      showLegendWorld: {},
      showAnimate: '',
      Authorization: '',
      feedbackType: {},// 反馈对话框
      reportInfo: null, // 市场研究报告
      qusetiontextarea: '',
      questionType: '',
      questionTypeText: this.$i18.language('精准回答'),
      lang: localStorage.getItem('language'),
      questionTypeList: [ // 问题类型
        {
          value: 1,
          key: 'check_supplier',
          text: this.$i18.language('查采购/供应商'),
        }, {
          value: 5,
          key: 'check_contacts_data',
          text: this.$i18.language('查联系人'),
        }, {
          value: 2,
          key: 'check_trade_data',
          text: this.$i18.language('查交易情报'),
        }, {
          value: 3,
          key: 'check_statistic',
          text: this.$i18.language('查统计数据'),
        }, {
          value: 4,
          key: 'read_MS_Report',
          text: this.$i18.language('解读市场研究报告'),
        }
      ],
    };
  },
  computed: {
    isShowLoading(){
      return index => {
        return this.answerLoading == 1 && index == this.dialoglist.length - 1 ? true : false
      }
    },
    isShowLoadingMore(){
      return index => {
        return this.answerLoading == 2 && this.isLoadingMore && index == this.dialoglist.length - 1 ? true : false
      }
    },
    isShowOption(){
      return index => {
        if (this.dialoglist.length - 1 >= 0) {
          return this.answerLoading != 0 && index == this.dialoglist.length - 1 ? false : true
        } else {
          return this.answerLoading != 0 ? false : true
        }
      }
    },
    Avatar() { //头像
      let accountInfo = localStorage.getItem("set_account_info")?JSON.parse(localStorage.getItem("set_account_info")):this.$store.getters.accountInfo;
      return accountInfo && accountInfo.email ? accountInfo.email.slice(0, 2).toUpperCase() : 'Aa'
    },
    getQuestionType() {
      return val => {
        return this.questionTypeList.filter(e=>e.value==val)[0].text
      }
    },
    webSearchTip() {
      return this.QA_args.webSearch?this.$i18.language("已开启 TradeGPT 对互联网访问的权限，将使用互联网数据进行回答。"):this.$i18.language("已关闭 TradeGPT 对互联网访问的权限，使用特易数据库进行回答。")
    },
    questionTypeIconName(){
      return this.questionTypeList.find(item => item.value === this.questionType)?.key
    }
  },
  watch: {
    questionType: {
      handler(newval){
        if (newval) {
          this.questionTypeText = `${this.$i18.language("已选精准回答")}`
        } else {
          this.questionTypeText = `${this.$i18.language("精准回答")}`
        }
      },
      // immediate: true,
      deep: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let { reportid, reportit, difyId } = this.$route.query
      if (reportid) {
        this.questionType = 4
        this.reportInfo = {
          id: reportid,
          title: reportit || '',
          difyId,
        }
      }
      let gt6_user_info = localStorage.getItem("gt6_user_info") ? JSON.parse(localStorage.getItem("gt6_user_info")) : ""
      let notShow = ["白银C版", "白银G版", "黄金C版", "黄金G版"]
      this.questionTypeList = notShow.includes(gt6_user_info.permission) || ["TR"].includes(this.$util.judgeOrigin()) ? this.questionTypeList.filter(e=>e.value!=3) : this.questionTypeList
    },
    selectReport(row) {
      this.reportInfo = row
    },
    sendQuest(text, reportInfo) {
      this.qusetiontextarea = text
      this.questionType = 4
      this.reportInfo = reportInfo
      this.$nextTick(()=>{
        this.$refs.inputRef.focus()
      })
    },
    setQusetType(val) {
      this.questionType = 4
      this.reportInfo = val
    },
    openWebSearch() {
      this.QA_args.webSearch = !this.QA_args.webSearch
    },
    changeReport() {
      this.$refs.marketReport.open()
    },
    clearBtn() {
      this.reportInfo = null
    },
    newDialog() {
      this.actDialogId = ''
      this.dialoglist = []
      this.notNew = false
      this.questionType = ''
      this.reportInfo = null
      this.answerLoading = 0 // 结束当前生成中的对话
    },
    changeActDialog(row) {
      this.actDialogId = row.sessionKey // 切换对应的会话ID(董越接口用sessionKey)
      this.getDialogHistory(row.id) // 拿对应会话的对话列表(熊航接口用id)
      this.questionType = '' // 重置对话类型
      this.answerLoading = 0 // 结束当前生成中的对话
          },
    checkLength: _.debounce(function () {
      if (this.qusetiontextarea.trim().length >= 1000) {
        return this.$message.warning(this.$i18.language("输入字符过长!"))
      }
    }, 300),
    changeInput(e) {
      console.log("changeInput");
      
      this.checkLength()
      if ((e.shiftKey || e.metaKey) && e.keyCode === 13) {
        // console.log('换行');
      } else if (!(e.shiftKey || e.metaKey) && e.keyCode === 13) {
        // console.log('发送');
        this.sendQusetion(e)
      }
    },
    getColumnsByDataType(dataType) {
      const mapping = new Map([
        [3, this.$columns.aiTradeData],
        [5, this.$columns.aiTradeCountryTable],
      ]);
      const columns = mapping.get(dataType);
      return columns || this.$columns.aiCompanyTable;
    },
    // 根据对话ID获取对话内容
    getDialogHistory(id){
      this.sessionLoading = true
      this.$api.ai.getGptSessionMsg({id}).then(res => {
        this.dialoglist = res.data.map(el=>{
          let reg = new RegExp('(?:<)?(https?:\\/\\/[^\\s，。；,;>)）\u4e00-\u9fa5]+)(?:>)?', 'g');
          if (!el.replyContent.includes("||")) {
            let jsonReply = JSON.parse(el.replyContent)
            jsonReply.msg.uniqueKey = el.uniqueKey
            // jsonReply.msg.replyContent = jsonReply.msg.replyContent.replace(reg, '<a href="$1" target="_blank"> $1 </a>');
            if (jsonReply.type == 'en-chat') {
              jsonReply.msg.jsonData = jsonReply.msg.dataType == -2 ? jsonReply.msg.tabledata : ""
              jsonReply.msg.tabledata = {
                columnData: this.getColumnsByDataType(jsonReply.msg.dataType),
                result: jsonReply.msg.tabledata,
                pageIndex: 1,
                pageSize: 10,
                total: 0,
              }
              return {...el, ...jsonReply.msg}
            } else {
              return {...el, ...jsonReply.msg, replyContent: jsonReply.msg.replyContent}
            }
          }
          let result = this.formatOutput(el.replyContent)
          // 使用正则表达式查找并替换网址并在其前后添加空格
          result.msg = result.msg.replace(reg, '<a href="$1" target="_blank"> $1 </a>');
          let jsonData
          // JSON.parse转json失败后尝试eval
          try {
            jsonData = JSON.parse(result.data)
          } catch (error) {
            jsonData = eval("(" + result.data + ")")
          }
          if (jsonData.type == -2) {
            return {
              ...el,
              jsonData: jsonData.tabledata,
              dataType: jsonData.type,
              replyContent: result.msg,
            }
          } else {
            return {
              ...el,
              dataType: jsonData.type,
              replyContent: result.msg,
              tabledata: {
                columnData: this.getColumnsByDataType(jsonData.type),
                result: jsonData.tabledata,
                pageIndex: 1,
                pageSize: 10,
                total: 0,
              }
            }
          }
        })
        this.sessionLoading = false
      })
      this.$forceUpdate()
    },
    // 重新生成
    async rebuild(item){
      if (this.answerLoading != 0 ) {
        return this.$message.warning(this.$i18.language('问题生成中'))
      }
      this.regenerated = 1
      this.answerLoading = 1
      // 往现有的dialoglist会话中追加对话项
      this.$set(this.dialoglist, this.dialoglist.length, {
        replyContent: '',
        sendContent: item.sendContent
      })
      // 滚动到底部
      this.$nextTick(()=>{
        this.$refs.dialogflex.scrollTo({top: this.$refs.dialogflex.scrollHeight, behavior: 'smooth'})
      })
      try {
        if (this.QA_args.webSearch) {
          let keys = {
            "et": "ai_websearch_auth",
            "demo": "ai_websearch_auth_demo",
          }
          let key = keys[process.env.NODE_ENV] ?? 'ai_websearch_auth'
          this.$api.trade.getCustomConfig(`${key}&parse=true`).then(res => {
            this.Authorization = res.data
            this.getDifyGpt(item.sendContent)
          })
        } else {
          await this.getDialog_V2(item.sendContent)
        }
      } catch (error) {
        this.answerLoading = 0 // 强制结束生成对话
      }
      // this.qusetiontextarea = item.sendContent
      // 获取当前输入框的焦点
      // this.$nextTick(()=>{
      //   this.$refs.inputRef.focus()
      // })
    },
    // 复制功能
    copy(row){
      if (!row) {
        return this.$message.warning(this.$i18n.language("内容不能为空"))
      }
      var clipboard = new Clipboard(`.copy-button`, {
        text: function () {
          return row || ''
        }
      })
      clipboard.on('success', (e) => {
        this.$message.success(this.$i18.language('复制成功'))
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        this.$message.warning(this.$i18.language('该浏览器不支持复制'))
        clipboard.destroy()
      })
    },
    // type: 1点赞、2信息错误、3没有帮助
    feedback(row, type){
      if (type == 1 && this.showAnimate == '') {
        this.showAnimate = row.uniqueKey
        setTimeout(() => {
          this.showAnimate = ''
        }, 800);
      }
      // 禁止重复点赞
      if (row.score == 1 && row.score == type) return false;
      let params = {
        uniqueKey: row.uniqueKey,
        score: type,
        cause: ''
      }
      // 如果是踩
      if (type != 1) {
        params.cause = row.cause
      }
      this.$api.ai.setMessageScore(params).then(res=>{
        if (res.code == 200) {
          let index = this.dialoglist.findIndex(e=>e.uniqueKey==row.uniqueKey)
          this.$set(this.dialoglist, index, {
            ...this.dialoglist[index],
            score: type
          })
        }
      })
    },
    moreFeedback(row){
      this.feedbackType = {
        row,
        dialogVisible: true,
      }
    },
    // 切换精准搜索类型
    changeQuestionType(val, isFromPreset){
      if (isFromPreset) {
        this.questionType = val.value
      } else {
        // 单选or取消单选
        this.questionType = this.questionType === val.value ? '' : val.value
      }
      if (this.questionType == 4) { // 市场研究报告取消联网
        this.QA_args.webSearch = false
      }
    },
    // 格式化输出文本
    formatOutput(input) {
      const hasDelimiter = input.includes("||");
      if (hasDelimiter) {
        // msg:AI文本流data:数据流
        return {msg: input.split('||')[0], data: input.split('||')[1]};
      } else {
        return {msg: input};
      }
    },
    saveGptLog(parsedData, index) {
      if (parsedData.conversation_id && parsedData.message_id) {
        let replyContent = JSON.stringify({type: "websearch", msg: {...this.dialoglist[index], webSearchList: parsedData.webSearchList}})
        let saveParams = {
          // sessionKey: parsedData.conversation_id,
          sessionKey: this.actDialogId?this.actDialogId:parsedData.conversation_id,
          uniqueKey: parsedData.message_id,
          sendContent: this.dialoglist[index].sendContent,
          replyContent,
          sendDate: this.formatTimestamp(parsedData.created_at),
          replyDate: this.formatTimestamp(parsedData.finished_at),
        }
        // console.log(saveParams);
        this.$api.ai.saveGptLog(saveParams).then(res => {
          this.$set(this.dialoglist, index, {
            ...this.dialoglist[index],
            score: 0,
            cause: "",
            uniqueKey: parsedData.message_id
          })
          // 如果是新提问,问完第一个问题之后将新生成的会话sessionKey赋值给actDialogId,用于连续问答
          if (this.actDialogId == '') {
            if (this.isRight != 1) { // 如果小易侧边栏(放大状态)或者正常GPT页面
              this.$emit('handleNewSession', parsedData.conversation_id)
            }
            this.actDialogId = parsedData.conversation_id
          }
        })
      }
    },
    scrollDown: _.throttle(function (preResponse) {
      // 处理滚动高度
      if (this.$refs.dialogflex.scrollHeight > preResponse.scrollHeight) {
        this.$refs.dialogflex.scrollTo({ top: this.$refs.dialogflex.scrollHeight, behavior: 'smooth' });
        preResponse.scrollHeight = this.$refs.dialogflex.scrollHeight;
      }
    }, 500),
    async getDifyGpt(question) {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", this.Authorization);
      myHeaders.append("Content-Type", "application/json");

      let reportInfo = {};
      if (this.questionType === 4 && this.reportInfo && this.reportInfo.id) {
        reportInfo = {
          id: this.reportInfo.id,
          title: this.reportInfo.title,
        };
      }
      let customerId = localStorage.getItem("gt6_user_info")?JSON.parse(localStorage.getItem("gt6_user_info")).customerId:''
      const raws = JSON.stringify({
        inputs: {
          token: localStorage.getItem('accessToken')
        },
        query: question || this.qusetiontextarea, // 提问内容
        response_mode: "streaming",
        conversation_id: this.actDialogId.startsWith("internal_") ? "" : this.actDialogId.slice(0, 36), // 会话ID
        user: customerId, // 用户信息
        files: []
      });

      const params = {
        method: 'POST',
        headers: myHeaders,
        body: raws,
      };
      const stream = await fetch("/v1/chat-messages", params);
      const reader = stream.body.getReader();
      this.answerLoading = 1;
      this.qusetiontextarea = '';
      let index = this.dialoglist.length - 1;
      if (index < 0) index = 0;
      
      let preResponse = {
        msg: '',
        data: {},
        state: 0,
        langChain: false,
        cacheMsg: "",
        webSearchList: [],
        scrollHeight: this.$refs.dialogflex.scrollHeight
      };

      const parser = createParser((event) => {
        if (event.type === 'event') {
          let parsedData;
          try {
            parsedData = JSON.parse(event.data);
            if (parsedData.event == "node_started" && parsedData.data.title == "search_xng") { // websearch
              this.answerLoading = 2
              this.$set(this.dialoglist[index], "searchState", 1)
              // this.$set(this.dialoglist[index], "webSearchList", [{text: this.$i18.language("正在尝试为您在互联网搜索相关资料..."), value: ""}])
              this.$set(this.dialoglist[index], "sendContent", this.dialoglist[index].sendContent)
            }
            if (parsedData.event == "node_finished" && parsedData.data.title == "websearch_excluded_url_post") { // websearch
              if (parsedData.data.outputs && parsedData.data.outputs && parsedData.data.outputs.text) {
                preResponse.webSearchList = parsedData.data.outputs.text.length?parsedData.data.outputs.text:[{text: this.$i18.language("暂未检索到互联网相关资料"), value: ""}]
                if (preResponse.webSearchList.length) {
                  let tempSearchList = []
                  let i = 0
                  this.$set(this.dialoglist[index], "searchState", 2)
                  let webSearchTimer = setInterval(() => {
                    if (i >= preResponse.webSearchList.length) return window.clearInterval(webSearchTimer);
                    tempSearchList.push(preResponse.webSearchList[i])
                    this.$set(this.dialoglist[index], "webSearchList", tempSearchList)
                    i += 1
                  }, 300);
                }
              }
            }
            if (parsedData.event == "node_started" && parsedData.data.node_type == "llm") { // llm回答开始
              // console.log("llm:node_started", this.dialoglist[index]);
              preResponse.state = 1
            }
            if (parsedData.event == "message" && preResponse.state == 1) {
              this.$set(this.dialoglist[index], "searchState", 3)
              let reg = new RegExp('(?:<)?(https?:\\/\\/[^\\s，。；,;>)）\u4e00-\u9fa5]+)(?:>)?', 'g');
              preResponse.msg += parsedData.answer
              this.$set(this.dialoglist[index], "replyContent", preResponse.msg.replace(reg, '<a href="$1" target="_blank"> $1 </a>'))
            }
            if (parsedData.event == "node_finished" && parsedData.data.node_type == "llm") { // llm回答结束
              // console.log("llm:node_finished", this.dialoglist[index].replyContent);
              // document.querySelectorAll(".answer-wrap").forEach(ele => {
              //   ele.querySelectorAll('a').forEach(link => {
              //     link.setAttribute('target', '_blank');
              //   });
              // })
              preResponse.state = 2
              preResponse = {
                ...preResponse,
                conversation_id: parsedData.conversation_id,
                message_id: parsedData.message_id,
                created_at: parsedData.created_at,
                finished_at: parsedData.data.finished_at,
              }
            }
            if (parsedData.event == "error") {
              preResponse.state = 2
              this.$set(this.dialoglist[index], "searchState", 3)
              this.$set(this.dialoglist[index], "replyContent", parsedData.message)
            }
            if (this.$refs.dialogflex.scrollHeight > preResponse.scrollHeight) {
              this.$refs.dialogflex.scrollTo({top: this.$refs.dialogflex.scrollHeight, behavior: 'smooth'})
              // 计算实时滚动高度
              preResponse.scrollHeight = this.$refs.dialogflex.scrollHeight
            }
            // console.log(parsedData);
          } catch (e) {
            return console.error('JSON parse error:', e);
          }
        }
      });

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          preResponse.conversation_id = preResponse.conversation_id + '-' + Date.now()
          this.saveGptLog(preResponse, index)
          setTimeout(() => {
            this.$refs.dialogflex.scrollTo({top: this.$refs.dialogflex.scrollHeight, behavior: 'smooth'})
          }, 500);
          this.isLoadingMore = false
          this.answerLoading = 0
          // console.log("**********done***********", preResponse);
          break;
        }

        const text = new TextDecoder().decode(value);
        parser.feed(text);
      }
    },
    async getDialog_V2(question){
      const isMarketReport = Number(this.questionType) === 4;
      const { difyId } = this.reportInfo || {};
      const isFormData = isMarketReport && difyId;
      const query = question || this.qusetiontextarea; // 提问内容
      const raws = JSON.stringify({
        query,
        language: this.lang,
        session_id: this.actDialogId, // 会话ID
      });

      const formData = new FormData();
      formData.append("class", "report");
      formData.append("dify_id", difyId);
      formData.append("query", query);
      formData.append("session_id", this.actDialogId);

      const baseHeaders = {
        "authorization": localStorage.getItem('accessToken'),
        "website": this.$util.getCurrentWebSite(),
        "unionkey": "gt6"
      };
      
      const headers = isFormData ? baseHeaders : { ...baseHeaders, "content-type": "application/json" };

      const params = {
        method: 'POST',
        headers,
        body: isFormData ? formData : raws,
      };
      const stream = await fetch("/api/chat/v1/completions", params);
      const reader = stream.body.getReader();
      this.answerLoading = 1;
      this.qusetiontextarea = '';
      let index = this.dialoglist.length - 1;
      if (index < 0) index = 0;
      
      let preResponse = {msg: '',data: {},
        loadText: "",
        progressIndex: 0,
        progressList: [],
        scrollHeight: this.$refs.dialogflex.scrollHeight
      };

      const parser = createParser((event) => {
        this.answerLoading = 2
        if (event.type === 'event') {
          let parsedData;
          try {
            parsedData = JSON.parse(event.data);
            if (parsedData.flag == "message") {
              preResponse.loadText += parsedData.answer
              this.$set(this.dialoglist, index, {
                searchType: "yisou",
                searchState: 1,
                searchText: preResponse.loadText,
                sendContent: this.dialoglist[index].sendContent
              })
            } else if (parsedData.flag == "StartLoadingMore") {
              this.isLoadingMore = true
            } else if (parsedData.flag == "EndLoadingMore") {
              this.isLoadingMore = false
            } else {
              preResponse.data = parsedData
              this.$set(this.dialoglist, index, {
                ...this.dialoglist[index],
                searchState: 3,
                replyContent: preResponse.msg += parsedData.answer,
                sendContent: this.dialoglist[index].sendContent
              }) 
              this.scrollDown(preResponse)
            }
          } catch {
            console.error("JSON parse error")
          }
        }
      });

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          let jsonData = preResponse.data
          this.$set(this.dialoglist, index, {
            ...this.dialoglist[index],
            score: 0,
            moreType: jsonData.moretype,
            dataType: jsonData.type,
            uniqueKey: jsonData.message_id,
            jsonData: jsonData.type == -2 ? jsonData.tableData : null,
            chartdata: jsonData.chartdata,
            tabledata: {
              columnData: this.getColumnsByDataType(jsonData.type),
              result: jsonData.tableData ? jsonData.tableData : [],
              pageIndex: 1,
              pageSize: 10,
              total: 0,
            }
          })
          if (this.actDialogId == '') {
            if (this.isRight != 1) { // 如果小易侧边栏(放大状态)或者正常GPT页面
              this.$emit('handleNewSession', jsonData.session_id)
            }
            this.actDialogId = jsonData.session_id
          }
          // console.log(preResponse);
          // console.log(this.dialoglist);
          // console.log(this.actDialogId, jsonData.session_id);
          setTimeout(() => {
            this.$refs.dialogflex.scrollTo({ top: this.$refs.dialogflex.scrollHeight, behavior: 'smooth' });
          }, 500);
          this.isLoadingMore = false;
          this.answerLoading = 0;
          break;
        }

        const text = new TextDecoder().decode(value);
        parser.feed(text);
      }
    },
    // async getDifyGpt(question) {
    //   // ... 前面的代码保持不变

    //   const context = new Context();
    //   context.index = this.dialoglist.length - 1;
    //   if (context.index < 0) context.index = 0;

    //   const parser = createParser((event) => {
    //     context.handleEvent(event, parser);

    //     // 处理滚动高度
    //     if (this.$refs.dialogflex.scrollHeight > context.preResponse.scrollHeight) {
    //       this.$refs.dialogflex.scrollTo({ top: this.$refs.dialogflex.scrollHeight, behavior: 'smooth' });
    //       context.preResponse.scrollHeight = this.$refs.dialogflex.scrollHeight;
    //     }
    //   });

    //   while (true) {
    //     const { done, value } = await reader.read();
    //     if (done) {
    //       context.preResponse.conversation_id = context.preResponse.conversation_id + '-' + Date.now();
    //       this.saveGptLog(context.preResponse, context.index);
    //       setTimeout(() => {
    //         this.$refs.dialogflex.scrollTo({ top: this.$refs.dialogflex.scrollHeight, behavior: 'smooth' });
    //       }, 500);
    //       this.isLoadingMore = false;
    //       this.answerLoading = 0;
    //       break;
    //     }

    //     const text = new TextDecoder().decode(value);
    //     parser.feed(text);
    //   }
    // }
    // 获取对话
    // async getDialog_V2(question){
    //   this.handleAddLogs(question || this.qusetiontextarea) // 提问埋点

    //   var myHeaders = new Headers();
    //   myHeaders.append("Authorization", localStorage.getItem('accessToken'));
    //   myHeaders.append("Content-Type", "application/json");

    //   let reportInfo = {}
    //   if (this.questionType==4 && this.reportInfo && this.reportInfo.id) {
    //     reportInfo = {
    //       id: this.reportInfo.id,
    //       title: this.reportInfo.title,
    //     }
    //   }
    //   var raw = JSON.stringify({
    //     "sessionKey": this.actDialogId == '' ? '' : this.actDialogId,
    //     "questionType": this.questionType, // 提问类型
    //     "prompt":  question || this.qusetiontextarea,
    //     "reportInfo":  reportInfo,
    //     "regenerated": this.regenerated // 是否重新生成
    //   });

    //   this.qusetiontextarea = ''
    //   var requestOptions = {
    //     method: 'POST',
    //     headers: myHeaders,
    //     body: raw,
    //     redirect: 'follow'
    //   };

    //   const response = await fetch("/v1/chat/chatStream", requestOptions);
    //   // if (response.status != 200) {
    //   //   return this.answerLoading = 0
    //   // }
    //   const reader = response.body.getReader();
    //   // msg:AI文本流data:数据流dataStream:数据流标识scrollHeight:滚动高度
    //   let responseData = {msg: '', data: '', dataStream: false, scrollHeight: this.$refs.dialogflex.scrollHeight};
    //   // json数据加载判断
    //   let timer, previousTime, nowTime
    //   timer = setInterval(() => {
    //     nowTime = Date.now()
    //     if (nowTime - previousTime > 300 && responseData.msg) {
    //       // console.log('大于300ms');
    //       this.isLoadingMore = true
    //       window.clearInterval(timer) // 清除定时器
    //     }
    //   }, 1000);
    //   this.answerLoading = 2

    //   while (this.answerLoading != 0) {
    //     const { value, done } = await reader.read();
    //     if (done) {
    //       // 读取完毕
    //       this.isLoadingMore = false
    //       window.clearInterval(timer) // 清除定时器
    //       let index = this.dialoglist.length - 1
    //       if (index < 0) {
    //         index = 0
    //       }
    //       // 使用正则表达式查找并替换网址并在其前后添加空格
    //       let reg = new RegExp('(?:<)?(https?:\\/\\/[^\\s，。；,;>\u4e00-\u9fa5]+)(?:>)?', 'g');
    //       this.$set(this.dialoglist[index], "replyContent", responseData.msg.replace(reg, '<a href="$1" target="_blank"> $1 </a>'))
    //       let jsonData
    //       try {
    //         jsonData = JSON.parse(responseData.data)
    //       } catch (error) {
    //         jsonData = eval("(" + responseData.data + ")")
    //       }
    //       // type为123时 有数据并绘制对应图表；为-1时是正常GPT对话(无数据渲染)；为-2时是市场研究报告分析(单独处理)
    //       if (jsonData.type > 0 || jsonData.type == -3) {
    //         this.$set(this.dialoglist, index, {
    //           ...this.dialoglist[index],
    //           score: 0,
    //           moreType: jsonData.moreType,
    //           dataType: jsonData.type,
    //           uniqueKey: jsonData.uniqueKey,
    //           tabledata: {
    //             columnData: jsonData.type==3?this.$columns.aiTradeData:this.$columns.aiCompanyTable,
    //             result: jsonData.tabledata,
    //             pageIndex: 1,
    //             pageSize: 10,
    //             total: 0,
    //           }
    //         })
    //       } else {
    //         this.$set(this.dialoglist, index, {
    //           ...this.dialoglist[index],
    //           score: 0,
    //           dataType: jsonData.type,
    //           jsonData: jsonData.tabledata,
    //           uniqueKey: jsonData.uniqueKey,
    //         })
    //       }

    //       // 滚动到底部
    //       setTimeout(() => {
    //         this.$refs.dialogflex.scrollTo({top: this.$refs.dialogflex.scrollHeight, behavior: 'smooth'})
    //       }, 500);

    //       // 如果是新提问,问完第一个问题之后将新生成的会话sessionKey赋值给actDialogId,用于连续问答
    //       if (this.actDialogId == '') {
    //         if (this.isRight != 1) { // 如果小易侧边栏(放大状态)或者正常GPT页面
    //           this.$emit('handleNewSession', jsonData.sessionKey)
    //         }
    //         this.actDialogId = jsonData.sessionKey
    //       }
          
    //       this.answerLoading = 0 // 结束生成对话
    //       this.regenerated = 0 // 默认不是重新生成
    //       // console.log('结束生成对话:', this.actDialogId, jsonData, this.dialoglist);
    //       break;
    //     } else {
    //       previousTime = Date.now()
    //       // 如果中途切换会话,立即终止对话生成
    //       if (this.answerLoading == 0) return false;
    //       // 每次输出的逻辑处理
    //       let index = this.dialoglist.length - 1
    //       let answer = this.formatOutput(new TextDecoder().decode(value))
    //       // 如果返回有data则之后的流都是数据流
    //       if (answer.data) {
    //         responseData.dataStream = true
    //       }
    //       // 如果是文本流
    //       if (responseData.dataStream) {
    //         if (answer.data) {
    //           responseData.data += answer.data
    //         } else {
    //           responseData.data += answer.msg
    //         }
    //       } else {
    //         this.$set(this.dialoglist, index, {
    //           replyContent: responseData.msg += answer.msg,
    //           sendContent: this.dialoglist[index].sendContent
    //         })
    //       }
    //       // console.log('数据流:', answer);
    //       // 判断是否换行继续滚动
    //       if (this.$refs.dialogflex.scrollHeight > responseData.scrollHeight) {
    //         this.$refs.dialogflex.scrollTo({top: this.$refs.dialogflex.scrollHeight, behavior: 'smooth'})
    //         // 计算实时滚动高度
    //         responseData.scrollHeight = this.$refs.dialogflex.scrollHeight
    //       }
    //       // 10秒内再无数据传回视为回答结束
    //       _.debounce(()=>{this.answerLoading = 0}, 10000)
    //     }
    //   }
    // },
    // 发送问题
    async sendQusetion(e, question){
      // 禁用换行
      e && e.preventDefault();
      if (e.isComposing) {
        return;
      }
      let target = e.target;
      if(target.nodeName == "SPAN"){
        target = e.target.parentNode;
      }
      target.blur();
      this.$refs.inputRef.blur()
      // 如果输入为空
      if (this.qusetiontextarea.trim().length <= 0) {
        return this.$message.warning(this.$i18.language('请输入问题'))
      }
      if (this.answerLoading != 0 ) {
        return this.$message.warning(this.$i18.language('问题生成中'))
      }
      this.answerLoading = 1

      // 如果第一次提问
      if (this.actDialogId == '') {
        this.notNew = true
        // 往新的dialoglist会话中push添加对话项
        this.dialoglist.push({
          replyContent: '',
          sendContent: this.qusetiontextarea
        })
      } else {
        // 往已有的dialoglist会话中追加对话项
        this.$set(this.dialoglist, this.dialoglist.length, {
          replyContent: '',
          sendContent: this.qusetiontextarea
        })
      }
      // 滚动到底部
      this.$nextTick(()=>{
        this.$refs.dialogflex.scrollTo({top: this.$refs.dialogflex.scrollHeight, behavior: 'smooth'})
      })
      try {
        if (this.QA_args.webSearch) {
          let keys = {
            "et": "ai_websearch_auth",
            "demo": "ai_websearch_auth_demo",
          }
          let key = keys[process.env.NODE_ENV] ?? 'ai_websearch_auth'
          this.$api.trade.getCustomConfig(`${key}&parse=true`).then(res => {
            this.Authorization = res.data
            this.getDifyGpt(question)
          })
        } else {
          await this.getDialog_V2(question)
        }
      } catch (error) {
        this.answerLoading = 0 // 强制结束生成对话
      }
    },
    // 提问时添加埋点
    handleAddLogs(question) {
      let data = sessionStorage.getItem("webLog")
      if(data) {
        data = JSON.parse(data)
        let value = { gpt_path: this.$route.path, gpt_question: question }
        let key = 'attribute'
        if (this.$route.path == '/analysis') {
          value.gpt_params = {...this.$store.getters.getMarketReportFilter}
        } else if (this.$route.path == '/analysis/detail') {
          value.gpt_params = { reportId: this.$route.query.id }
        }
        this.$set(data, key, `trade_gpt: ${JSON.stringify(value)}`);
        this.$api.logs.addWebLogs(data)
      }
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000); // 假设时间戳是秒级，需要乘以1000转换为毫秒级
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  },
};
</script>

<style scoped lang="scss">
@import '../scss/sessionBox';
@import '../scss/markdown';
</style>
<style>
.websearch-popover {
  padding: 5px 8px !important;
}
</style>
